import { render, staticRenderFns } from "./head_page_1.vue?vue&type=template&id=3b260f1e&scoped=true&"
import script from "./head_page_1.vue?vue&type=script&lang=js&"
export * from "./head_page_1.vue?vue&type=script&lang=js&"
import style0 from "./head_page_1.vue?vue&type=style&index=0&id=3b260f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b260f1e",
  null
  
)

export default component.exports